import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { blogPosts } from '../data/blog';
export function Blog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-24 pb-20 bg-[#f] dark:bg-[#252423] min-h-screen" data-id="element-1959" data-mp="vv2e3hadxu2y">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1960" data-mp="qx0sopphliob">
        <header className="mb-12 text-center" data-id="element-1961" data-mp="qvhed4ne5hp6">
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-brand-charcoal dark:text-white tracking-tight uppercase" data-id="element-1962" data-mp="38rby274rl41">
            Blog: Guides & Tips
          </h1>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1963" data-mp="cykksvfw1m4l">
          {blogPosts.map((post, idx) => <motion.article key={post.slug} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white dark:bg-[#333333] rounded-2xl overflow-hidden shadow-sm border border-stone-200 dark:border-white/10 hover:shadow-md transition-shadow flex flex-col" data-id="element-1964" data-mp="8610zgqlxurc" data-mpi={idx}>
              <Link to={`/blog/${post.slug}`} className="block aspect-video overflow-hidden" data-id="element-1965" data-mp="273f78dq1pe6a">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-1966" data-mp="2bw89muy1kaf7" />
              </Link>
              <div className="p-6 flex flex-col flex-grow" data-id="element-1967" data-mp="1j6rl48djldo9">
                <p className="text-sm text-brand-muted dark:text-stone-400 italic mb-2" data-id="element-1968" data-mp="1j8cgu1blf2np">
                  {post.date}
                </p>
                <Link to={`/blog/${post.slug}`} data-id="element-1969" data-mp="1s7g0p7il3m39">
                  <h2 className="font-heading text-xl font-extrabold text-brand-charcoal dark:text-white uppercase mb-3 hover:text-brand-orange transition-colors" data-id="element-1970" data-mp="1s5mshnsbott5">
                    {post.title}
                  </h2>
                </Link>
                <p className="text-brand-muted dark:text-stone-300 text-sm leading-relaxed flex-grow" data-id="element-1971" data-mp="38lfwc6aecpkp">
                  {post.excerpt}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </main>;
}